import React, { useState, useEffect } from 'react';
import { api } from '../../api';
import RelatoriosProducao from '../cargas/RelatoriosProducao';
import Estado from '../../components/ui/Estado';
import PageHeader from '../../components/ui/PageHeader';

/**
 * Relatório de produção sob o macro Relatórios.
 * Reusa o mesmo componente da aba Relatórios em Colheita.
 */
export default function RelatorioProducaoPage() {
  const [armazens, setArmazens] = useState([]);
  const [safras, setSafras] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    setCarregando(true);
    setErro('');
    Promise.all([api.getArmazens(), api.getSafras()])
      .then(([arm, saf]) => {
        setArmazens(arm || []);
        setSafras(saf || []);
      })
      .catch((e) => setErro(e.message || 'Não foi possível carregar os filtros.'))
      .finally(() => setCarregando(false));
  }, []);

  return (
    <div>
      <PageHeader
        titulo="Produção"
        icone="producao"
        descricao="Cargas por período, armazém, safra e área. Também na aba Relatórios de Colheita."
        voltar={{ to: '/relatorios', label: 'Relatórios' }}
      />
      <Estado carregando={carregando} erro={erro} itens={4}>
        <RelatoriosProducao armazens={armazens} safras={safras} mostrarTitulo={false} />
      </Estado>
    </div>
  );
}
